import React from 'react'

const Exit = () => {
    return (
        <div className="Exit--option">
            <p>Esc</p>
        </div>
    )
}

export default Exit;